// 可視範圍的高度
const funcWebViewHeight = function () {
  let windows = $(window);
  let bodyView = $(document.body);

  // 全域高度
  $('.fullbox').css({
    width: bodyView.outerWidth(),
    height: bodyView.outerHeight()
  });

  // 隨裝置寬度更新視窗寬高
  windows.resize(function () {
    $('.fullbox').css({
      width: windows.width(),
      height: windows.height()
    });
  });
};

// Diagnosis 的列表高度
const funcWebDiagnosis = function () {
  let nowWindow = $(window);
  let allheight = nowWindow.height();
  let listheight = allheight - 158;

  $('.nav_diagnosis').css({
    height: listheight
  });

  $(window).resize(function () {
    $('.nav_diagnosis').css({
      height: nowWindow.listheight
    });
  });
};

// Reference Tree Style
const funcTreeListOpen = function () {
  let target = $('.tree_styleList li >a');

  target.click(function (e) {
    $(this)
      .parent()
      .toggleClass('open');
    $(this)
      .parent()
      .children('ul')
      .slideToggle('500');
  });
};

// 獲取當前瀏覽器類型
const funcBrowserType = function () {
  const userAgent = navigator.userAgent; // 取得瀏覽器的userAgent字符串
  const indexOfStrZero = -1;
  const isOpera = userAgent.indexOf('Opera') > indexOfStrZero;
  const isFirefox = userAgent.indexOf('Firefox') > indexOfStrZero;
  const isChrome = userAgent.indexOf('Chrome') > indexOfStrZero;
  const isSafari = userAgent.indexOf('Safari') > indexOfStrZero;

  if (isOpera) {
    // 判斷是否Opera瀏覽器
    return 'Opera';
  }
  if (isFirefox) {
    // 判斷是否Firefox瀏覽器
    return 'FF';
  }
  if (isChrome) {
    // 判斷是否Safari瀏覽器
    return 'Chrome';
  }
  if (isSafari) {
    // 判斷是否Safari瀏覽器
    return 'Safari';
  }
  if (userAgent.indexOf('compatible') > indexOfStrZero && userAgent.indexOf('MSIE') > indexOfStrZero && !isOpera) { // 判斷是否IE瀏覽器
    return 'IE';
  }
};

// 數字範圍
const funcIntRange = function (intVal, intMax, intMin) {
  return intVal >= intMin && intVal <= intMax;
};

// bike error code Mapping
const funcErrorCodeMap = function (errCode) {
  let strErrorCode = errCode.toString();
  switch (strErrorCode) {
    case '16':
    case '17':
    case '18':
    case '19':
      return 'torqueSensor';
    case '20':
    case '21':
    case '22':
    case '23':
      return 'frontTpms';
    case '24':
    case '25':
    case '26':
    case '27':
      return 'GPX';
    case '32':
    case '33':
    case '34':
    case '35':
    case '36':
    case '37':
    case '38':
    case '39':
    case '40':
      return 'motor';
    case '44':
    case '45':
    case '46':
    case '47':
      return 'rearTpms';
    case '48':
    case '49':
      return 'speedSensor';
    case '55':
    case '56':
    case '59':
    case '60':
    case '61':
    case '62':
    case '63':
      return 'accessory';
    case '64':
    case '65':
    case '66':
    case '67':
    case '68':
    case '69':
    case '70':
    case '71':
    case '72':
    case '73':
    case '74':
    case '75':
    case '76':
    case '77':
    case '78':
    case '79':
      return 'battery';
    case '80':
    case '81':
    case '82':
    case '83':
    case '84':
    case '85':
    case '86':
    case '87':
    case '88':
    case '89':
    case '90':
    case '91':
    case '92':
      return 'driver';
    case '96':
    case '97':
    case '98':
    case '99':
    case '100':
    case '101':
      return 'consoleDisplay';
    case '112':
      return 'frontLight';
    case '113':
      return 'maintenance';
    case '114':
      return 'bluetooth';
    case '115':
      return 'brakeSensor';
    case '116':
      return 'rearLight';
    case '117':
      return 'other';
    case '119':
    case '200':
    case '204':
    case '205':
    case '206':
    case '209':
    case '210':
    case '212':
    case '213':
    case '214':
    case '216':
    case '217':
    case '218':
    case '220':
    case '221':
    case '222':
    case '223':
    case '224':
    case '225':
    case '226':
    case '227':
    case '228':
    case '229':
    case '232':
    case '233':
    case '234':
    case '235':
    case '236':
    case '237':
      return 'brseDriver';
    default:
      return errCode;
  }
};

export { funcWebDiagnosis, funcWebViewHeight, funcTreeListOpen, funcBrowserType, funcIntRange, funcErrorCodeMap };
